import React from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import PageLayout from '../common/PageLayout';
import PortalTopNav from './PortalTopNav';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Shared shell for devotee portal routes and public /donate — same PageLayout + top nav row as PortalLayout.
 */
export default function PortalChrome({ children, navDisabled = false }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { staff, logout } = useAuth();
  const onDonateRoute = location.pathname.startsWith('/donate');

  return (
    <PageLayout contentMaxWidth="xl" showHeaderImage={false} hideSignedInBar>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: { xs: 'stretch', md: 'center' },
          justifyContent: 'space-between',
          gap: { xs: 1.5, md: 2 },
          mb: 2.5,
          flexWrap: 'wrap',
        }}
      >
        <Box sx={{ flex: '1 1 auto', minWidth: 0 }}>
          <PortalTopNav disabled={navDisabled} />
        </Box>
        {staff ? (
          <Box
            sx={{
              flex: '0 0 auto',
              display: 'flex',
              alignItems: 'center',
              justifyContent: { xs: 'flex-start', md: 'flex-end' },
              gap: 1.5,
              flexWrap: 'wrap',
            }}
          >
            <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
              Signed in as <strong>{staff?.name || staff?.email || 'User'}</strong>
            </Typography>
            <Button
              variant="contained"
              color="error"
              size="small"
              startIcon={<LogoutIcon />}
              onClick={async () => {
                await logout();
                navigate('/login');
              }}
            >
              Log out
            </Button>
          </Box>
        ) : onDonateRoute ? (
          <Box
            sx={{
              flex: '0 0 auto',
              display: 'flex',
              alignItems: 'center',
              justifyContent: { xs: 'flex-start', md: 'flex-end' },
            }}
          >
            <Button
              component={NavLink}
              to="/login"
              variant="outlined"
              color="primary"
              size="small"
              sx={{ fontWeight: 700 }}
            >
              Login
            </Button>
          </Box>
        ) : null}
      </Box>
      {children}
    </PageLayout>
  );
}
